module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-dialog', {
    attrs: {
      "title": _vm.title,
      "visible": _vm.dialogVisible,
      "size": "small",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "label-width": "160px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "销售下单号"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.OrderData.OrderCode))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "销售下单时间"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.OrderData.OrderTime))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "订单状态"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.OrderData.OrderStatusName))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "发货状态"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.OrderData.SendStatusName))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "代理商"
    }
  }, [_c('div', [_c('span', [_vm._v(_vm._s(_vm.OrderData.AgentCode) + " " + _vm._s(_vm.OrderData.AgentName) + " " + _vm._s(_vm.OrderData.AgentAddress) + " " + _vm._s(_vm.OrderData.AgentTel))]), _vm._v(" "), _c('div', [_vm._v("独家代理区域：" + _vm._s(this.details.area))]), _vm._v(" "), _c('div', [_vm._v("已付定金：" + _vm._s(this.details.ContractMoney) + "元")])])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "所选套餐"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.OrderData.PackageName))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "业务员"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.OrderData.SaleEmployeeName))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "订单价格"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.OrderData.OrderPrice) + "元 ")]), _vm._v("\n                    (本期应收款:" + _vm._s(_vm.OrderData.DiscountTemplet.FirstOrderActualPrice) + ";二期应收款:" + _vm._s(_vm.OrderData.DiscountTemplet.TwoOrderActualPrice) + ")\n            ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "商品"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "data": _vm.OrderData.GoodsList,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "ProductName",
      "label": "商品名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ProNum",
      "label": "商品数量"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ProNum",
      "label": "本次发货数量"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "收货地址"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.OrderData.ProvName) + _vm._s(_vm.OrderData.CityName) + _vm._s(_vm.OrderData.AreaName) + _vm._s(_vm.OrderData.Address))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "收货人及联系方式"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.OrderData.Consignee) + "  " + _vm._s(_vm.OrderData.ConsigneeTel))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "寄送方式"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.OrderData.SendModeName))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "支付方式"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.OrderData.PayModeName))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "下单备注"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.OrderData.OrderRemark))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "审核备注"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "disabled": _vm.isReadOnly
    },
    model: {
      value: (_vm.auditFormData.AuditRemark),
      callback: function($$v) {
        _vm.$set(_vm.auditFormData, "AuditRemark", $$v)
      },
      expression: "auditFormData.AuditRemark"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    on: {
      "click": _vm.dialogClose
    }
  }, [_vm._v("关闭")]), _vm._v(" "), (!_vm.isReadOnly) ? _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("审核通过")]) : _vm._e()], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-10de6cf8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Order/orderAudit/components/paymentAuditOrder/index.vue
// module id = 1383
// module chunks = 1